const sectionQualityAndInFlightMap = {
  'clear_scope': 'Clear scope',
  'engaged_stakeholders': 'Engaged stakeholders',
  'governance_enabled': 'Governance enabled decision making',
  'focused_benefits_management': 'Focused benefits management',
  'managed_risks': 'Managed risk and opportunities',
  'smart_financing': 'Smart financing',
  'delivery_enabling_plans': 'Delivery-enabling plans',
  'active_quality': 'Active quality management',
  'agile_change_control': 'Agile change control',
  'integrated_suppliers': 'Integrated suppliers (and clients)',
  'high_performing_teams': 'High performing teams',
  'embedded_lifecycle': 'Embedded lifecycle assurance and learning',
  'final': 'Overall'
}

export { sectionQualityAndInFlightMap }